/**
 * Browser Notification Service
 * Sends native browser/PWA notifications for booking events.
 * Only fires if user granted permission AND notifications are enabled in settings.
 */
import { getSetting } from './offlineStorage';

export function sendBrowserNotification(title, body, tag) {
  if (!('Notification' in window)) return;
  if (Notification.permission !== 'granted') return;
  if (!getSetting('notifications_enabled', true)) return;

  try {
    const n = new Notification(title, {
      body,
      icon: '/favicon.ico',
      tag: tag || 'superhost-' + Date.now(),
      badge: '/favicon.ico',
      vibrate: getSetting('sound_enabled', true) ? [200, 100, 200] : undefined,
      silent: !getSetting('sound_enabled', true),
    });
    n.onclick = () => {
      window.focus();
      n.close();
    };
    setTimeout(() => n.close(), 8000);
  } catch (e) {
    console.warn('[BrowserNotif] Failed:', e);
  }
}
